<template>
  <a
    class="gift-tracking-card"
    :href="giftLink"
    target="_blank"
    rel="noopener"
  >
    <div class="gift-tracking-card__heading">
      {{ 'Вам подарок от\u00A0наших партнеров' }}
    </div>
    <div class="gift-tracking-card__btn">
      Получить подарок
    </div>
  </a>
</template>

<script>
import checkIsLending from '../../helpers/checkIsLending';

export default {
  name: 'GiftTrackingCard',
  computed: {
    giftLink() {
      return checkIsLending() ? 'https://get4click.ru/ext/37DNGWV3': 'https://get4click.ru/ext/EB9T6F7Q';
    },
  },
};
</script>

<style lang="scss" scoped>
.gift-tracking-card {
  position: relative;
  display: flex;
  align-items: center;
  padding: 23px 161px 23px 35px;
  min-height: 85px;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  background: #F6F6F6;
  border-radius: 10px;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("https://storage.yandexcloud.net/boxberrysite-public/b_images/gift-desktop.png") no-repeat calc(100% - 20px) bottom;
    background-size: 190px 85px;
    pointer-events: none;
    user-select: none;
  }
  @media(max-width: 767px) {
    padding: 21px 79px 17px 19px;
    min-height: 64px;
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.15);
    &:after {
      background: url("https://storage.yandexcloud.net/boxberrysite-public/b_images/gift-mobile.png") no-repeat right bottom;
      background-size: 105px 64px;
    }
  }
}
.gift-tracking-card__heading {
  margin-right: 14px;
  font-size: 22px;
  line-height: 25px;
  font-weight: 700;
  color: #ED1651;
  @media(max-width: 767px) {
    margin-right: 7px;
    font-size: 10px;
    line-height: 13px;
  }
}
.gift-tracking-card__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  min-width: 253px;
  min-height: 39px;
  padding: 5px 15px;
  font-weight: 700;
  font-size: 22px;
  leading-trim: Cap height;
  line-height: 25px;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color: #FFFFFF;
  border-radius: 100px;
  background-color:  #A6CE3A;
  white-space: nowrap;
  flex-shrink: 0;
  @media(max-width: 767px) {
    padding: 4px 10px 3px 10px;
    font-size: 10px;
    line-height: 13px;
    min-width: 118px;
    min-height: 24px;
  }
}
</style>
